/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./XYDialog.vue?vue&type=template&id=09d3f4b6&scoped=true"
import script from "./XYDialog.vue?vue&type=script&lang=js"
export * from "./XYDialog.vue?vue&type=script&lang=js"
import style0 from "./XYDialog.vue?vue&type=style&index=0&id=09d3f4b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d3f4b6",
  null
  
)

export default component.exports